import React from "react";

import {
  DualRowItem,
  RegularField,
  SelectField,
} from "../InputFields/InputFields";

function PatientDetailsFields(props) {
  const {
    uniqueID,
    setUniqueID,
    uniqueIDWarning,

    fullName,
    setFullName,
    fullNameWarning,

    email,
    setEmail,
    emailWarning,

    firstName,
    setFirstName,
    firstNameWarning,

    lastName,
    setLastName,
    lastNameWarning,

    phoneOne,
    setPhoneOne,
    phoneOneWarning,

    phoneTwo,
    setPhoneTwo,
    phoneTwoWarning,

    address,
    setAddress,
    addressWarning,

    healthID,
    setHealthID,
    healthIDWarning,

    birthDate,
    setBirthDate,
    birthDateWarning,

    height,
    setHeight,
    heightWarning,

    weight,
    setWeight,
    weightWarning,

    sex,
    setSex,
    sexWarning,
  } = props;

  const DEPLOYMENT_TYPE = process.env.REACT_APP_DEPLOYMENT_TYPE;
  const disableFields = DEPLOYMENT_TYPE === "demo";

  return (
    <div className="flex flex-col items-center justify-center w-full Xbg-red-500">
      {/* Unique patient ID */}
      <div className="flex flex-row items-center justify-center w-full">
        <RegularField
          value={uniqueID}
          setFunction={setUniqueID}
          fieldWarning={uniqueIDWarning}
          fieldDisabled={false}
          fieldLabel={"Unique Patient ID"}
          placeholderText={"e.g., 0112358 (required)"}
          fieldType="text"
          takeFullWidth={true}
        />
      </div>

      {/* Full name and Email */}
      <DualRowItem
        leftChild={
          <RegularField
            value={fullName}
            setFunction={setFullName}
            fieldWarning={fullNameWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Full Name"}
            placeholderText={"e.g., John Smith (optional)"}
            fieldType="text"
            takeFullWidth={true}
          />
        }
        rightChild={
          <RegularField
            value={email}
            setFunction={setEmail}
            fieldWarning={emailWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Email"}
            placeholderText={"e.g., john-smith@mail.com (optional)"}
            fieldType="email"
            takeFullWidth={true}
          />
        }
      />

      {/* First name and Last name */}
      <DualRowItem
        leftChild={
          <RegularField
            value={firstName}
            setFunction={setFirstName}
            fieldWarning={firstNameWarning}
            fieldDisabled={disableFields}
            fieldLabel={"First Name"}
            placeholderText={"e.g., John (optional)"}
            fieldType="text"
            takeFullWidth={true}
          />
        }
        rightChild={
          <RegularField
            value={lastName}
            setFunction={setLastName}
            fieldWarning={lastNameWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Last Name"}
            placeholderText={"e.g., Smith (optional)"}
            fieldType="text"
            takeFullWidth={true}
          />
        }
      />

      {/* Phone one and Phone two */}
      <DualRowItem
        leftChild={
          <RegularField
            value={phoneOne}
            setFunction={setPhoneOne}
            fieldWarning={phoneOneWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Primary Telephone"}
            placeholderText={"e.g., 1+ 123-456-7890 (optional)"}
            fieldType="tel"
            takeFullWidth={true}
          />
        }
        rightChild={
          <RegularField
            value={phoneTwo}
            setFunction={setPhoneTwo}
            fieldWarning={phoneTwoWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Secondary Telephone"}
            placeholderText={"e.g., 1+ 123-456-7890 (optional)"}
            fieldType="tel"
            takeFullWidth={true}
          />
        }
      />

      {/* Address one and Health card ID */}
      <DualRowItem
        leftChild={
          <RegularField
            value={address}
            setFunction={setAddress}
            fieldWarning={addressWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Address"}
            placeholderText={"e.g., Some Street 123 (optional)"}
            fieldType="text"
            takeFullWidth={true}
          />
        }
        rightChild={
          <RegularField
            value={healthID}
            setFunction={setHealthID}
            fieldWarning={healthIDWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Health Card ID"}
            placeholderText={"e.g., 0123-456-789-AB (optional)"}
            fieldType="text"
            takeFullWidth={true}
          />
        }
      />

      {/* Birth date and Height */}
      <DualRowItem
        leftChild={
          <RegularField
            value={birthDate}
            setFunction={setBirthDate}
            fieldWarning={birthDateWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Birth Date"}
            placeholderText={"Birth Date (optional)"}
            fieldType="date"
            takeFullWidth={true}
          />
        }
        rightChild={
          <RegularField
            value={height}
            setFunction={setHeight}
            fieldWarning={heightWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Height (cm)"}
            placeholderText={"e.g., 175 (optional)"}
            fieldType="number"
            takeFullWidth={true}
          />
        }
      />

      {/* Weight and Sex */}
      <DualRowItem
        leftChild={
          <RegularField
            value={weight}
            setFunction={setWeight}
            fieldWarning={weightWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Weight (kg)"}
            placeholderText={"e.g., 75 (optional)"}
            fieldType="number"
            takeFullWidth={true}
          />
        }
        rightChild={
          <SelectField
            value={sex}
            setFunction={setSex}
            fieldWarning={sexWarning}
            fieldDisabled={disableFields}
            fieldLabel={"Sex"}
            placeholderText={"Select Sex (optional)"}
            options={["Male", "Female", "Other"]}
            takeFullWidth={true}
          />
        }
      />
    </div>
  );
}

export default PatientDetailsFields;
